export default __webpack_public_path__ + "static/media/Search_Icon.28b39a2e.svg";